import { render } from "./LessonAccesses.vue?vue&type=template&id=3414c83a"
import script from "./LessonAccesses.vue?vue&type=script&lang=js"
export * from "./LessonAccesses.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__